import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'
import { ReportingOrder } from 'api/orderManagement/types'
import React from 'react'

interface OrderModalProps {
  isOpen: boolean
  onClose: (_event: Record<string, never>, _reason: 'backdropClick' | 'escapeKeyDown') => void
  onSubmit: (event: React.MouseEvent<HTMLButtonElement>) => Promise<any>
  order: ReportingOrder | null
  title: string
  description: string
  submitText: string
}

const OrderModal: React.FC<OrderModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  order,
  title,
  description,
  submitText,
}) => {
  if (!order) return null

  const handleClose = (_event: React.MouseEvent<HTMLButtonElement>) => {
    onClose({} as Record<string, never>, 'backdropClick')
  }

  const handleSubmit = async (event: React.MouseEvent<HTMLButtonElement>) => {
    try {
      const response = await onSubmit(event)
      if (response?.ready_at) {
        order.attributes.ready_at = response.ready_at
      }
      onClose({} as Record<string, never>, 'backdropClick')
    } catch (error) {
      console.error('Error handling submit:', error)
    }
  }

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth='sm'
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '8px',
          padding: '16px',
        },
      }}
    >
      <DialogTitle>
        <Typography variant='h6' sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant='body1' sx={{ color: 'text.secondary', margin: 'auto' }}>
          {description}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ padding: '16px', gap: '8px' }}>
        <Button
          variant='outlined'
          onClick={handleClose}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            borderColor: 'grey.300',
            '&:hover': {
              borderColor: 'grey.400',
            },
          }}
        >
          Cancel
        </Button>
        <Button
          variant='contained'
          onClick={handleSubmit}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            backgroundColor: 'primary.main',
            '&:hover': {
              backgroundColor: 'primary.dark',
            },
          }}
        >
          {submitText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default OrderModal
